export const Language: string = "zh-cn";

export const TOKEN_KEY: string = "TOKEN";
export const TOKEN_NAME: string = "Authorization";

export const TOKEN_STANDBY: string = "TokenStandby";


// 静态资源地址
export const PREVIEW_DOMAIN: string = "https://lint.eci.games";
// 图片预览地址
// 使用地方: src/utils/brower/image.ts
export const PREVIEW_IMAGE: string = "https://lint.eci.games/pageview/online/onlinePreview";

export const HelpLink: string = "https://comiloc.eci.games/comicHelp/help";
